const videos = [{
    id: 99,
    title: "React js Tutorial",
    views: "110k",
    time: "1 year ago",
    channel: "Channel 1 tut",
    verified: true,

},
{
    id: 25,
    title: "Node js Tutorial",
    views: "50k",
    time: "7 year ago",
    channel: "Channel 2 tut",
    verified: false
},
{
    id: 90,
    title: "TypeScript js Tutorial",
    views: "910k",
    time: "3 year ago",
    channel: "Channel 3 ",
    verified: true
},
{
    id: 80,
    title: "MongoDB  Tutorial",
    views: "910k",
    time: "3 year ago",
    channel: "Channel 3 ",
    verified: true
},
{
    id: 30,
    title: "MongoDB  Tutorial",
    views: "910k",
    time: "3 year ago",
    channel: "Channel 3 ",
    verified: true
},
{
    id: 50,
    title: "MongoDB  Tutorial",
    views: "910k",
    time: "3 year ago",
    channel: "Channel 3 ",
    verified: true
}]

export default videos;